/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChatMetadata {
    getFixupPrototypeFunction() { return ChatMetadata.fixupPrototype; }

    static newInstance(model: Partial<ChatMetadata>): ChatMetadata {
        let obj = Object.assign(new ChatMetadata(), model);
        ChatMetadata.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChatMetadata>): ChatMetadata {
        if (!model) return null;
        return ChatMetadata.newInstance(<ChatMetadata> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChatMetadata) {
        if (!obj) return;

        models.ChatMetadata.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChatMetadata): boolean {
        Object.setPrototypeOf(obj, ChatMetadata.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Last state ID
     */
    last_state: string;

    /**
     * Name of the framework
     */
    framework_name: string;

}
